export default (() => {
    const els = Array.from(document.querySelectorAll('.toggled-tab-access'));

    els.forEach((el) => {
        if (!el.classList.contains('toggled')) {
            el.classList.add('invisible');
        }
        el.addEventListener('toggledOn', () => {
            el.classList.remove('invisible');
        });
        el.addEventListener('toggledOff', () => {
            setTimeout(() => {
                el.classList.add('invisible');
            }, 600);
        });
    });
})();
